export default "__VITE_ASSET__CZ8RZKu4__"